<template>
  <div class="my-1 card">
    <div class="my-0 py-1 card-header text-info">
      <h4 class="my-0 py-1">
        Select Incident Type, Sub Offering Type and Lawfirm
      </h4>
      <small class="form-text text-muted"
        >For the selected country
        {{ countryfilter(this.$store.getters.selectedCountry) }}</small
      >
    </div>
    <div class="card-body">
      <div class="form-group">
        <label for="exampleInputEmail1">Country</label>
        <select
          @change="selectedCountry(country)"
          :disabled="true"
          v-model="country"
          class="form-control w-50"
          id="incidentTypeList"
          aria-describedby="incidentTypeHelp"
        >
          <option
            v-for="ser in masterData.countries"
            v-bind:key="ser.id"
            v-bind:value="ser.slug"
          >
            {{ ser.title }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label for="exampleInputEmail1">Incident Type</label>
        <select
          :disabled="createAgainMode || newMdrRenewal"
          v-model="incidentType"
          class="form-control w-50"
          id="incidentTypeList"
          aria-describedby="incidentTypeHelp"
          @change="selectedincidentType(incidentType)"
        >
          <option
            v-for="ser in masterData.incidentTypes"
            v-bind:key="ser.id"
            v-bind:value="ser.slug"
          >
            {{ ser.title }}
          </option>
        </select>
        <small id="incidentTypeHelp" class="form-text text-muted">
          Please select the type of the incident that this project corresponds
          to
        </small>
      </div>
      <div class="form-group">
        <label for="exampleInputEmail1">Sub Offering Type</label>
        <select
          :disabled="createAgainMode && this.$store.getters.selectedIncidentType != 'it-mdr'"
          v-model="subofferingType"
          class="form-control w-50"
          id="incidentTypeList"
          aria-describedby="incidentTypeHelp"
        >
          <option
            v-for="ser in masterData.subofferingTypes"
            v-bind:key="ser.id"
            v-bind:value="ser.slug"
          >
            {{ ser.title }}
          </option>
        </select>
        <small id="incidentTypeHelp" class="form-text text-muted">
          Please select the type of the suboffering that this project
          corresponds to
        </small>
      </div>
      <div class="form-group">
        <label for="exampleInputEmail1">Lawfirm</label>
        <select
          :disabled="createAgainMode"
          v-model="lawfirm"
          class="form-control w-50"
          id="lawfirmList"
          aria-describedby="lawfirmHelp"
        >
          <option
            v-for="ser in masterData.lawfirms"
            v-bind:key="ser.id"
            v-bind:value="ser.slug"
          >
            {{ ser.title }}
          </option>
        </select>
        <small id="lawfirmHelp" class="form-text text-muted"
          >Please select the Lawfirm that this SoW corresponds to</small
        >
      </div>
      <div v-if="false" class="form-group">
        <label for="exampleInputEmail1">Choose Services</label>
        <div v-bind:key="ser.Slug" v-for="ser in services">
          <span class="d-inline-block custom-control custom-checkbox">
            <input
              type="checkbox"
              v-model="ser.isSelected"
              v-bind:id="ser.Slug"
              v-bind:key="ser.Slug"
              class="custom-control-input"
            />
            <label class="custom-control-label" v-bind:for="ser.Slug">
              {{ ser.Title }}
            </label>
          </span>
          <font-awesome-icon
            v-bind:key="ser.Slug"
            size="sm"
            title="is optional?"
            v-if="ser.isSelected && !ser.isOptional"
            class="d-inline-block ml-2 text-info"
            @click="ser.isOptional = !ser.isOptional"
            v-bind:icon="['fa', 'toggle-off']"
          ></font-awesome-icon>
          <font-awesome-icon
            size="sm"
            v-bind:key="ser.Slug"
            v-if="ser.isSelected && ser.isOptional"
            title="is optional?"
            class="d-inline-block ml-2 text-info"
            @click="ser.isOptional = !ser.isOptional"
            v-bind:icon="['fa', 'toggle-on']"
          ></font-awesome-icon>
        </div>
        <small id="lawfirmHelp" class="form-text text-muted">
          Selected services will drive the tasks and scope in the generated SoW
        </small>
      </div>

      <button
        class="btn btn-secondary"
        @click="goback"
        v-if="!this.$store.getters.amendmentMode"
      >
        <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon
        >Back
      </button>
      <button
        class="btn btn-info mx-2"
        v-bind:disabled="nextable"
        @click="gonext"
      >
        Next
        <font-awesome-icon :icon="['fas', 'arrow-right']"></font-awesome-icon>
      </button>
    </div>
  </div>
</template>
<script>
import serviceProxy from "../services/index";
import _ from "lodash";
export default {
  name: "SelectTemplate",
  // mounted() {
  //   // if (this.$route.params.lawfirm) {
  //   //   this.lawfirm = this.$route.params.lawfirm;
  //   // }
  // },
  created() {
    var that = this;
    // let country = that.$store.getters.selectedCountry.toUpperCase()
    //   ? that.$store.getters.selectedCountry.toUpperCase()
    //   : "";
    this.country = this.$store.getters.selectedCountry;
    that.$root.$emit("stage", 1);
    this.getRateCards();
    if (!that.$store.getters.hasMasterData) {
      that.$root.$emit("progress");
      that.$root.$emit("toast", {
        title: "Fetching Data",
        message: "Fetching the Master Data",
      });
      this.getMasterData();
    } else {
      let mrdata = _.clone(that.$store.getters.masterData);
      console.log(mrdata);
      let selectedLawfirm = that.$store.getters.selectedLawfirm;
      let selectedIncidentType = that.$store.getters.selectedIncidentType;
      let selectedSubofferingType = that.$store.getters.selectedSubofferingType;
      mrdata.incidentTypes = this.createAgainMode
        ? mrdata.incidentTypes
        : mrdata.incidentTypes;
      that.masterData = _.clone(mrdata);
      console.log(that.masterData);
      that.masterData.lawfirms = _.filter(
        that.masterData.lawfirms,
        (lm) => lm.countrySlug === this.$store.getters.selectedCountry
      );
      // let selServices = that.$store.getters.selectedServices;
      //let selectedCarrier = that.$store.getters.selectedCarrier;
      //that.carrier = selectedCarrier;
      that.lawfirm = selectedLawfirm;
      that.incidentType = selectedIncidentType;
      that.subofferingType = selectedSubofferingType;
      if (this.newMdrRenewal) {
        this.incidentType = "it-mdr";
      }
      this.selectedincidentType(selectedIncidentType);
      // Filter based on country
      /*that.services = _.map(mrdata.services, ser => {
        var selService = _.find(
          selServices,
          selser => selser.Slug === ser.Slug
        );
        if (selService) {
          ser.isSelected = selService.isSelected ? true : false;
          ser.isOptional = selService.isOptional ? true : false;
        } else {
          ser.isSelected = false;
          ser.isOptional = false;
        }
        return ser;
      });*/
    }
  },
  filters: {
    uppercase: function (value, onlyFirstCharacter) {
      if (!value) {
        return "";
      }
      value = value.toString();
      if (onlyFirstCharacter) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      } else {
        return value.toUpperCase();
      }
    },
  },
  methods: {
    getRateCards() {
      let that = this;
      that.$root.$emit("progress");
      serviceProxy.master
        .getRateCards(this.$store.getters.token)
        .then((data) => {
          let rateCardsList = data.data.data;
          this.$store.commit("rateCardsList", {
            rateCards: rateCardsList,
          });
          that.$root.$emit("done");
        })
        .catch((e) => {
          //console.log(e);
          that.$root.$emit("done");
        });
    },
    goback: function () {
      this.$router.go(-1);
    },
    gonext: function () {
      // var services = _.filter(this.services, ser=>{
      //   return ser.isSelected;
      // });

      let selectedIncident = _.filter(
        this.$store.getters.masterData.incidentTypes,
        (lm) => lm.slug === this.incidentType
      );
      this.selectedIncidentTypeTitle = selectedIncident[0].title;

      let selectedSuboffering = _.filter(
        this.$store.getters.masterData.subofferingTypes,
        (lm) => lm.slug === this.subofferingType
      );
      this.selectedsubofferingTypeTitle = selectedSuboffering[0].title;

      let selectedLawfirm = _.filter(
        this.$store.getters.masterData.lawfirms,
        (lm) => lm.slug === this.lawfirm
      );
      this.selectedLawfirmTitle = selectedLawfirm[0].title;

      this.$store.commit("settings", {
        //  services: services,
        //carrier: this.carrier,
        subofferingType: this.subofferingType,
        documenttype: this.$store.getters.selectedDocumenttype,
        manualclient: this.$store.getters.selectedManualClient,
        isNewClient: this.$store.getters.isnewClient,
        country: this.country,
        client: this.$store.getters.selectedClient,
        lawfirm: this.lawfirm,
        incidentType: this.incidentType,
        incidentTypeTitle: this.selectedIncidentTypeTitle,
        subofferingTypeTitle: this.selectedsubofferingTypeTitle,
        lawfirmTitle: this.selectedLawfirmTitle,
      });
      this.$router.push({ path: "fill-placeholders" });
    },
    countryfilter(value) {
      let that = this;
      if (!value) {
        return "";
      }
      value = value.toString();
      let country = _.filter(
        that.$store.getters.masterData.countries,
        (lm) => lm.slug === value
      );
      return country[0].title;
    },
    templateselected: function () {},
    selectedCountry(country) {
      let that = this;
      that.masterData.lawfirms = _.filter(
        that.$store.getters.masterData.lawfirms,
        (lm) => lm.countrySlug === this.country
      );
    },
    selectedincidentType(incidentType) {
      let that = this;
      that.masterData.subofferingTypes = null;
      let subofftype = _.clone(that.$store.getters.masterData.subofferingTypes);
      that.masterData.subofferingTypes = _.filter(
        subofftype,
        (lm) =>
          lm.incidentTypeSlug.toLowerCase() === that.incidentType.toLowerCase()
      );
      // let country = that.$store.getters.selectedCountry
      //   ? that.$store.getters.selectedCountry.toUpperCase()
      //   : "";
      if (
        that.incidentType == "it-mdr" ||
        that.incidentType == "it-post-ir" ||
        that.incidentType == "it-msp" ||
        that.incidentType == "it-msp-con-acc-ren"
      ) {
        this.lawfirm = _.filter(
          that.masterData.lawfirms,
          (mr) => mr.slug.indexOf("lf-nol-") > -1
        )[0].slug;
      }
    },
    getMasterData() {
      let that = this;
      that.$root.$emit("progress");
      serviceProxy.master
        .getMasterData(this.$store.getters.token)
        .then((data) => {
          let mrdata = data.data.data;
          console.log(mrdata);
          let services = _.filter(mrdata.services, (mr) => mr.isActive);
          let lawfirms = _.filter(mrdata.lawfirms, (mr) => mr.isActive);
          let incidentTypes = _.filter(
            mrdata.incidentTypes,
            (mr) => mr.isActive
          );
          let documents = _.filter(mrdata.documentTypes, (mr) => mr.isActive);
          let countries = _.filter(mrdata.countries, (mr) => mr.isActive);
          let subofferingTypes = mrdata.subofferingTypes;
          that.masterData.subofferingTypes = _.clone(subofferingTypes);
          that.masterData.countries = _.clone(countries);
          that.masterData.documentType = _.clone(documents);
          let masterData = {
            services,
            lawfirms,
            incidentTypes,
            documents,
            countries,
            subofferingTypes,
          };
          that.$store.commit("populateMR", masterData);
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "Data Fetched",
            message: "Fetched the MasterData",
          });
        })
        .catch((e) => {
          //console.log(e);
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "OOPS",
            message: "Error in fetching the data",
          });
        });
    },
  },
  computed: {
    nextable() {
      return !(this.incidentType && this.lawfirm && this.subofferingType); // && this.services.length > 0);
    },
  },
  data() {
    return {
      masterData: {},
      lawfirm: "",
      incidentType: "",
      country: "",
      isManualClient: this.$store.getters.selectedManualClient ? false : true,
      selectedIncidentTypeTitle: "",
      selectedsubofferingTypeTitle: "",
      services: [],
      optionalservices: [],
      subofferingType: "",
      createAgainMode: this.$store.getters.createAgainMode,
      newMdrRenewal: this.$store.getters.amendmentMode
        ? false
        : this.$store.getters.newMdrRenewal,
      //carrier: ""
    };
  },
  watch: {
    services: function (newservice, oldservice) {
      console.log("service changed");
    },
    lawfirm: function (newLawfirm, oldLawfirm) {
      if (!this.createAgainMode && oldLawfirm) {
        this.$store.commit("templateconfig", null);
        this.$store.commit("servicesConfig", null);
      }
      // this.$router.replace({
      //   name: "select-template",
      //   params: {
      //     lawfirm: newLawfirm
      //   }
      // });
    },
    incidentType: function (newIncidentType, oldIncidentType) {
      if (!this.createAgainMode && oldIncidentType) {
        this.$store.commit("templateconfig", null);
        this.$store.commit("servicesConfig", null);
      }
      // this.$router.replace({
      //   name: "select-template",
      //   params: {
      //     lawfirm: newLawfirm
      //   }
      // });
    },
    subofferingType: function (newSuboffering, oldSuboffering) {
      if (!this.createAgainMode && oldSuboffering) {
        this.$store.commit("templateconfig", null);
        this.$store.commit("servicesConfig", null);
      }else if(this.createAgainMode && oldSuboffering){
        this.$store.commit("mdrtemplateconfig", null);
      }
      // this.$router.replace({
      //   name: "select-template",
      //   params: {
      //     lawfirm: newLawfirm
      //   }
      // });
    },
  },
  props: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
